import React from 'react';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';

class LzFormFieldBase extends React.Component {

    render() {
        const { fluid, required, icon, id, name, style, className, label, labelShrink, hintText, children } = this.props;

        const theName = name ? name : '';
        const theId = id ? id : 'id_' + theName;

        const styles = style || { display: fluid ? "block" : "inline-block" };

        return (
            <div
                id={theId}
                className={'lz-input-field ' + (className || '')}
                style={styles}
            >

                {label && <InputLabel className='lz-label' shrink={labelShrink}>
                    {icon && <React.Fragment>{icon} </React.Fragment>}
                    {label}
                    {required && <b> *</b>}
                </InputLabel>}

                {children}

                {hintText !== '' && <FormHelperText>{hintText}</FormHelperText>}

            </div>
        );
    }

}

export default LzFormFieldBase;
